export default "__VITE_ASSET__ukA87$_7__"